import { render, staticRenderFns } from "./CompBlackBox.vue?vue&type=template&id=b70ea03a"
import script from "./CompBlackBox.vue?vue&type=script&lang=js"
export * from "./CompBlackBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports